<div class="details mb-5">
  <div class="form-group">
    <label for="">QTY OnHand</label>
    <span
      class="value"
      *ngIf="rfq.stock && rfq.stock.qty_onhand; else qty_onhand_zero"
      >{{ rfq?.stock.qty_onhand | number }}</span
    >
    <ng-template #qty_onhand_zero>
      <span class="value">0</span>
    </ng-template>
  </div>
  <div class="form-group">
    <label for="">QTY Incoming</label>
    <span
      *ngIf="rfq.stock && rfq.stock.qty_incoming; else qty_incoming_zero"
      class="value"
    >
      {{ rfq?.stock.qty_incoming | number }}
    </span>
    <ng-template #qty_incoming_zero>
      <span class="value">0</span>
    </ng-template>
    <!-- <span class="value">{{rfq.qty_incoming | currency:' '}}</span> -->
  </div>
  <div class="form-group">
    <label for="">QTY Available</label>
    <span class="value" *ngIf="rfq.stock; else qty_available_zero">{{
      rfq?.stock.qty_onhand - rfq?.stock.qty_pending | number
    }}</span>
    <ng-template #qty_available_zero>
      <span class="value">0</span>
    </ng-template>
  </div>
  <div class="form-group">
    <label for="">QTY Pending</label>
    <span
      class="value"
      *ngIf="rfq.stock && rfq.stock.qty_pending; else qty_pending_zero"
      >{{ rfq?.stock.qty_pending | number }}</span
    >
    <ng-template #qty_pending_zero>
      <span class="value">0</span>
    </ng-template>
  </div>

  <div class="form-group">
    <label for="">Last Month Sale Qty</label>
    <span *ngIf="rfq.last_month_sale; else last_month_sale_zero" class="value">{{
      rfq?.last_month_sale.quantity | number
    }}</span>
    <ng-template #last_month_sale_zero>
      <span class="value">0</span>
    </ng-template>
  </div>
  <div class="form-group">
    <label for="">Month-to-date Sale Qty</label>
    <span
      *ngIf="rfq.month_to_date_sale; else month_to_date_sale_zero"
      class="value"
      >{{ rfq?.month_to_date_sale.quantity | number }}</span
    >
    <ng-template #month_to_date_sale_zero>
      <span class="value">0</span>
    </ng-template>
  </div>
</div>

<h6 [translate]="'GENERAL.GETTING_RECORDS'" class="text-center m-5" *ngIf="loading">
  <i class="fas fa-spinner fa-spin"></i> Getting chart data...
</h6>

<div class="chart" *ngIf="!loading">
  <div class="chart text-center mb-5">
    <h3 class="title">Monthly Sales</h3>
    <ngx-charts-line-chart
      class="monthly-sales-qty-chart"
      [view]="view"
      [scheme]="colorScheme"
      [legend]="legend"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [xAxis]="xAxis"
      [yAxis]="yAxis"
      [xAxisLabel]="axisLabels.qty.x"
      [yAxisLabel]="axisLabels.qty.y"
      [timeline]="timeline"
      [results]="chartData"
    >
    </ngx-charts-line-chart>
  </div>
</div>
